import { createFileRoute, Navigate } from '@tanstack/react-router';
import { getDefaultView } from '@/utils/viewHelpers';
import { DocumentHead } from '@/components/core/DocumentHead';

export const Route = createFileRoute(
  '/$tenantId/_layout/travellers/$travellerId/',
)({
  component: TravellerRedirect,
});

function TravellerRedirect() {
  const { tenantId, travellerId } = Route.useParams();
  const view = getDefaultView('traveller');

  return (
    <>
      <DocumentHead
        titleKey="page.traveller.details.title"
        descriptionKey="page.traveller.details.description"
        resetOnUnmount={false}
      />
      <Navigate
        to="/$tenantId/travellers/$travellerId/$view"
        params={{ tenantId, travellerId, view }}
        replace
      />
    </>
  );
}
